import React from "react";
import { ProductDashboard } from "@core/components/products/dashboard/ProductDashboard";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";

const FormPollsDashboard: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Barre haute avec connexion */}
      <ProductHeader productType="form" showAuth={true} />

      {/* Contenu principal avec sidebar */}
      <div className="flex">
        {/* Sidebar auto-suffisante avec son hamburger */}
        <ProductSidebar productType="form" />

        {/* Contenu principal */}
        <div className="flex-1">
          <ProductDashboard productType="form" />
        </div>
      </div>
    </div>
  );
};

export default FormPollsDashboard;
